"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STAGING_COLLECTOR_URL = exports.DEV_COLLECTOR_URL = exports.MINI_COLLECTOR_URL = exports.MICRO_COLLECTOR_URL = exports.STAGING_HOSTNAMES = exports.DEV_HOSTNAMES = exports.DOMAIN_USER_INFO_ARRAY_INDEXES = void 0;
const types_1 = require("./types");
/**
 * Map of array indexes for the array returned from window.snowplow.getDomainUserInfo()
 * Taken from: https://docs.snowplow.io/docs/sources/trackers/javascript-trackers/web-tracker/cookies-and-local-storage/getting-cookie-values/#getdomainuserinfo
 */
exports.DOMAIN_USER_INFO_ARRAY_INDEXES = {
    DOMAIN_USER_ID: 1,
    SESSION_ID: 6,
};
exports.DEV_HOSTNAMES = {
    [types_1.SnowplowRegion.US]: [
        'dev.angi.cloud',
        'stagealf',
        'stagebravo',
        'stagecharlie',
        'stagedelta',
        'stageecho',
        'stagefoxtrot',
        'stagegolf',
        'stagehotel',
        'stageindigo',
        'stagejuliett',
        'stagekilo',
        'stagelima',
        'stagemike',
        'stagenovember',
        'stageoscar',
        'stagepapa',
        'stagequebec',
        'stageromeo',
        'stagesierra',
        'stagetango',
        'stageuniform',
        'stagevictor',
        'stageuniform',
        'stagevictor',
    ],
    [types_1.SnowplowRegion.EU]: [],
};
exports.STAGING_HOSTNAMES = {
    [types_1.SnowplowRegion.US]: [
        'staging.angi.cloud',
        'test.angi.cloud',
        'stage4.angi',
        'stage5.angi',
        'stage5a.angi',
        'qa3.homeadvisor',
        'qa3-pro.homeadvisor',
    ],
    [types_1.SnowplowRegion.EU]: [
        'staging.werkspot',
        'staging.travaux',
        'staging.my-hammer',
        'staging.instapro',
        'staging.mybuilder',
        'staging.homestars',
    ],
};
exports.MICRO_COLLECTOR_URL = 'http://localhost:9090';
exports.MINI_COLLECTOR_URL = {
    [types_1.SnowplowRegion.US]: 'https://com-angi-dev1.mini.snplow.net',
    [types_1.SnowplowRegion.EU]: 'https://com-angi-dev1eu.mini.snplow.net',
};
exports.DEV_COLLECTOR_URL = {
    [types_1.SnowplowRegion.US]: 'https://com-angi-dev1.collector.snplow.net',
    [types_1.SnowplowRegion.EU]: 'https://com-angi-dev1eu.collector.snplow.net',
};
exports.STAGING_COLLECTOR_URL = {
    [types_1.SnowplowRegion.US]: 'https://com-angi-qa1.collector.snplow.net',
    [types_1.SnowplowRegion.EU]: 'https://com-angi-qa1eu.collector.snplow.net',
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uc3RhbnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3V0aWxzL2NvbnN0YW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxtQ0FBeUM7QUFFekM7OztHQUdHO0FBQ1UsUUFBQSw4QkFBOEIsR0FBRztJQUMxQyxjQUFjLEVBQUUsQ0FBQztJQUNqQixVQUFVLEVBQUUsQ0FBQztDQUNoQixDQUFDO0FBRVcsUUFBQSxhQUFhLEdBQXFDO0lBQzNELENBQUMsc0JBQWMsQ0FBQyxFQUFFLENBQUMsRUFBRTtRQUNqQixnQkFBZ0I7UUFDaEIsVUFBVTtRQUNWLFlBQVk7UUFDWixjQUFjO1FBQ2QsWUFBWTtRQUNaLFdBQVc7UUFDWCxjQUFjO1FBQ2QsV0FBVztRQUNYLFlBQVk7UUFDWixhQUFhO1FBQ2IsY0FBYztRQUNkLFdBQVc7UUFDWCxXQUFXO1FBQ1gsV0FBVztRQUNYLGVBQWU7UUFDZixZQUFZO1FBQ1osV0FBVztRQUNYLGFBQWE7UUFDYixZQUFZO1FBQ1osYUFBYTtRQUNiLFlBQVk7UUFDWixjQUFjO1FBQ2QsYUFBYTtRQUNiLGNBQWM7UUFDZCxhQUFhO0tBQ2hCO0lBQ0QsQ0FBQyxzQkFBYyxDQUFDLEVBQUUsQ0FBQyxFQUFFLEVBQUU7Q0FDMUIsQ0FBQztBQUVXLFFBQUEsaUJBQWlCLEdBQXFDO0lBQy9ELENBQUMsc0JBQWMsQ0FBQyxFQUFFLENBQUMsRUFBRTtRQUNqQixvQkFBb0I7UUFDcEIsaUJBQWlCO1FBQ2pCLGFBQWE7UUFDYixhQUFhO1FBQ2IsY0FBYztRQUNkLGlCQUFpQjtRQUNqQixxQkFBcUI7S0FDeEI7SUFDRCxDQUFDLHNCQUFjLENBQUMsRUFBRSxDQUFDLEVBQUU7UUFDakIsa0JBQWtCO1FBQ2xCLGlCQUFpQjtRQUNqQixtQkFBbUI7UUFDbkIsa0JBQWtCO1FBQ2xCLG1CQUFtQjtRQUNuQixtQkFBbUI7S0FDdEI7Q0FDSixDQUFDO0FBRVcsUUFBQSxtQkFBbUIsR0FBRyx1QkFBdUIsQ0FBQztBQUU5QyxRQUFBLGtCQUFrQixHQUFtQztJQUM5RCxDQUFDLHNCQUFjLENBQUMsRUFBRSxDQUFDLEVBQUUsdUNBQXVDO0lBQzVELENBQUMsc0JBQWMsQ0FBQyxFQUFFLENBQUMsRUFBRSx5Q0FBeUM7Q0FDakUsQ0FBQztBQUVXLFFBQUEsaUJBQWlCLEdBQW1DO0lBQzdELENBQUMsc0JBQWMsQ0FBQyxFQUFFLENBQUMsRUFBRSw0Q0FBNEM7SUFDakUsQ0FBQyxzQkFBYyxDQUFDLEVBQUUsQ0FBQyxFQUFFLDhDQUE4QztDQUN0RSxDQUFDO0FBRVcsUUFBQSxxQkFBcUIsR0FBbUM7SUFDakUsQ0FBQyxzQkFBYyxDQUFDLEVBQUUsQ0FBQyxFQUFFLDJDQUEyQztJQUNoRSxDQUFDLHNCQUFjLENBQUMsRUFBRSxDQUFDLEVBQUUsNkNBQTZDO0NBQ3JFLENBQUMifQ==


// WEBPACK FOOTER //
// ../../../src/utils/constants.ts